<template>
	<div>
		<aside class="search-btn">
			<vButtonGroup class="tablelist-tabs clearfix" compact>
				<vButton
					size="large"
					v-for="(item,index) in btnsearch"
					:key="index"
					:theme="formData.itemstatus===item.value?'primary':'default'"
					@click="handleBtn('status',item.value)"
				>{{item.label}}</vButton>
			</vButtonGroup>
			<!--  费用对比汇总 -->
			<compCostall v-if="formData.itemstatus==1"></compCostall>
			<!-- 费用对比明细 -->
			<compCostdetail v-if="formData.itemstatus==0"></compCostdetail>
		</aside>
	</div>
</template>
<script>
import compTablelist from "@components/templates/tablelist";
import compCostall from "./costall.js";
import compCostdetail from "./costdetail.js";

export default {
	components: {
		compTablelist,
		compCostall,
		compCostdetail
	},
	data() {
		return {
			btnsearch: [{
				value: 1,
				label: this.$t('fbb.analyze.costcomparetotal',{defaultValue:'费用对比汇总'})
			}, {
				value: 0,
				label: this.$t('fbb.analyze.costcomparedetail',{defaultValue:'费用对比明细'})
			},],
			formData: {
				itemstatus: 1,
			}
		}
	},
	computed: {
		columns() {
			return [

			]
		}
	},
	methods: {
		handleBtn(type, value) {
			// console.log(2222)
			this.formData.itemstatus = value
		}
	},
}
</script>
